import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M15.2 5.625c0-.92-.538-1.667-1.458-1.667H5.2v12.084h8.542c.92 0 1.458-.747 1.458-1.667v-8.75Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M8.306 14h3.788c.42 0 .744-.561.548-1.138C12.353 12.013 11.696 11 10.2 11c-1.495 0-2.153 1.013-2.441 1.862-.196.577.127 1.138.547 1.138ZM11.7 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);